import { Toolbar } from "primereact/toolbar";
import { IPermissionProps } from "../../models/Login";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { IModal } from "./CallingExtension";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IFilter } from "./Filter";

export interface IExtensionCalling {
    extension_ID?: number,
    callerID?: string,
    ext_Destination?: string,
    displayName?: string,
};

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
}

export const EmptyExtCalling = {
    displayName: "",
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IExtensionCalling>, loading: boolean });
    const dt = useRef<any>(null);
    const [callFilter, setCallFilter] = useState<IFilter>(EmptyFilter);

    const leftToolbarTemplate = () => {
        return (

            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Calling Extension</h5>
        </div>
    );
    const loadCallHistory = async (rowData: any) => {
        //setTableData({ tableData: tableData.tableData, loading: true });
        const response = await fetch("https://billing.vitelglobal.com/vitelglobal_callrecords.php?username=Tekinspirations&password=UpBl9aEdDXo5OTHL&line=" + `${rowData.ext_Destination}` + "&startdate=2025-03-01&enddate=2025-03-19");
        if (response) {
        }
        const data = await response.json();
        //  setTableData({ tableData: data, loading: false });
    };


    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyExtCalling });
    };
    const openEdit = (rowData: IExtensionCalling) => {
        props.setModal({ open: true, singleData: rowData });
    };
    const action = (rowData: IExtensionCalling) => {
        return (
            <div className="flex gap-3">
                <Button className="pi pi-pencil text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button>
                {/* <Button className="pi pi-phone text-primary bg-white border-none" onClick={() => loadCallHistory(rowData)}></Button> */}
                {/* <Button className="pi pi-envelope text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button> */}
                {/* <Button className="pi pi-history text-primary bg-white border-none" onClick={() => openEdit(rowData)}></Button> */}

            </div>
        );
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Calling_Extension", "GET", null, `filter=${JSON.stringify(callFilter)}`, props.toast);
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    useEffect(() => {
        loadTableData();
    }, [props.reload,callFilter]);

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter callFilter={callFilter} setCallFilter={(callFilter: any) => setCallFilter(callFilter)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData.tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="callerID" header="Caller ID" />
                <Column field="ext_Destination" header="Ext/ Designation" />
                <Column field="displayName" header="Display Name" />
                <Column field="ivR_Company" header="IVR Company" />
                <Column field="branch_Name" header="Branch Name" />
                <Column field="" header="Action" body={action} />
            </DataTable>
        </>
    );
}